import template from './catalog.html'
import './catalog.styl'

let component = {
  restrict: 'E',
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/catalog/catalog.component.js